var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","app-version":_vm.appVersion},on:{"click":_vm.closeEvents}},[_c('vue-snotify'),_c('v-error-modal',{attrs:{"name":"error-modal"}}),_c('v2-media-library-selector',{attrs:{"showLibrary":_vm.showMediaLibrary,"data":_vm.currentMediaLibraryData}}),(
      _vm.teams[_vm.$route.params.team] &&
      _vm.teams[_vm.$route.params.team].account !== null &&
      _vm.teams[_vm.$route.params.team].authenticated &&
      _vm.teams[_vm.$route.params.team].account.team.subscription !== null
    )?_c('div',{staticClass:"extra-wrapper"},[_c('v-spinner',{staticClass:"content-spinner",attrs:{"loading":_vm.isLoading || _vm.isCustomLoading}}),_c('v2-sidebar-mobile',{attrs:{"links":_vm.sidebarMobileLinks,"teams":_vm.authenticatedTeams,"currentTeam":_vm.currentTeam,"signOutFromTeam":(obj) => {
          _vm.logout({
            logoutAllTeams: obj.logoutAllTeams,
            logoutThisTeam: obj.logoutThisTeam,
          });
        }},on:{"beforeTeamSelectOpen":_vm.sessionClosedLogout}}),_c('v2-sidebar',{attrs:{"minimized":this.teamsSettings[this.$route.params.team].sidebarIsMinimized,"links":_vm.sidebarLinks,"currentTeam":_vm.currentTeam,"teams":_vm.authenticatedTeams,"signOutFromTeam":(obj) => {
          _vm.logout({
            logoutAllTeams: obj.logoutAllTeams,
            logoutThisTeam: obj.logoutThisTeam,
          });
        }},on:{"beforeTeamSelectOpen":_vm.sessionClosedLogout,"sidebarIsMinimized":_vm.toggleMinimzedState}}),_c('main',{class:{
        'sidebar-minimized': this.teamsSettings[this.$route.params.team].sidebarIsMinimized,
      }},[_c('router-view',{key:_vm.$route.fullPath})],1)],1):_vm._e(),(
      !_vm.teams[_vm.$route.params.team] ||
      (_vm.teams[_vm.$route.params.team] && !_vm.teams[_vm.$route.params.team].authenticated) ||
      (_vm.teams[_vm.$route.params.team] &&
        _vm.teams[_vm.$route.params.team].authenticated &&
        _vm.teams[_vm.$route.params.team].account.team.subscription === null)
    )?_c('div',{staticClass:"extra-wrapper"},[_c('router-view',{key:_vm.$route.fullPath})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }